import isLightColor from "common/utils/isLightColor";
import stringToColor from "common/utils/stringToColor";
import Icon, { IconNames } from "components/Icon/Icon";

type Props = {
  label: string;
  color?: string;
  iconName?: IconNames;
  className?: string;
};

function TypeBadge({ label, color, iconName, className }: Props) {
  // Génère automatiquement une couleur basée sur le label si aucune couleur n'est fournie
  const backgroundColor = color || stringToColor(label);

  return (
    <div
      className={`flex flex-row w-fit gap-2 items-center p-1 px-2 rounded-md ${className}`}
      style={{ backgroundColor }}
    >
      {iconName && (
        <Icon
          name={iconName}
          className="h-4 w-4"
          style={{
            color: isLightColor(backgroundColor) ? "black" : "white",
          }}
        />
      )}
      <span
        className="text-sm"
        style={{
          color: isLightColor(backgroundColor) ? "black" : "white",
        }}
      >
        {label}
      </span>
    </div>
  );
}

export default TypeBadge;
